"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_EpisodeOfCare_StatusHistory = exports.EpisodeOfCare_StatusHistoryStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Period_1 = require("./RTTI_Period");
var EpisodeOfCare_StatusHistoryStatusKind;
(function (EpisodeOfCare_StatusHistoryStatusKind) {
    EpisodeOfCare_StatusHistoryStatusKind["_planned"] = "planned";
    EpisodeOfCare_StatusHistoryStatusKind["_waitlist"] = "waitlist";
    EpisodeOfCare_StatusHistoryStatusKind["_active"] = "active";
    EpisodeOfCare_StatusHistoryStatusKind["_onhold"] = "onhold";
    EpisodeOfCare_StatusHistoryStatusKind["_finished"] = "finished";
    EpisodeOfCare_StatusHistoryStatusKind["_cancelled"] = "cancelled";
    EpisodeOfCare_StatusHistoryStatusKind["_enteredInError"] = "entered-in-error";
})(EpisodeOfCare_StatusHistoryStatusKind = exports.EpisodeOfCare_StatusHistoryStatusKind || (exports.EpisodeOfCare_StatusHistoryStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_EpisodeOfCare_StatusHistory = t.recursion('IEpisodeOfCare_StatusHistory', function () {
    return t.intersection([
        t.type({
            period: RTTI_Period_1.RTTI_Period
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            status: (0, EnumType_1.createEnumType)(EpisodeOfCare_StatusHistoryStatusKind, 'EpisodeOfCare_StatusHistoryStatusKind'),
            _status: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_EpisodeOfCare_StatusHistory.js.map